import { Popover as Popover$1 } from "@mui/material";
import PropTypes from "prop-types";
import React__default, { useEffect, useState } from "react";
import useStyles from "./PopoverStyles.js";
const Popover = ({
  isOpen,
  onClose,
  anchorEl = null,
  children = null,
  style = {},
  anchorOrigin = {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin = {
    vertical: "top",
    horizontal: "left"
  },
  innerStyle = {},
  innerProps = {}
}) => {
  const classes = useStyles();
  useEffect(() => {
  }, [anchorEl, isOpen]);
  const [hasOpened, setHasOpened] = useState(isOpen);
  useEffect(() => {
    if (isOpen) {
      setHasOpened(true);
    }
  }, [isOpen]);
  if (!hasOpened) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
  }
  return /* @__PURE__ */ React__default.createElement(
    Popover$1,
    {
      anchorEl,
      keepMounted: false,
      open: isOpen,
      onClose,
      className: classes.popover,
      anchorOrigin,
      transformOrigin,
      style: { ...style },
      sx: { ...style },
      PaperProps: {
        style: {
          marginTop: "24px",
          // position: 'absolute',
          padding: "16px",
          // top: '25px',
          // left: '10px',
          boxShadow: "0px 4px 14px rgba(111, 111, 111, 0.25)",
          borderRadius: "18px",
          ...innerStyle
        }
      },
      ...innerProps
    },
    children
  );
};
Popover.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  style: PropTypes.shape({}),
  // eslint-disable-next-line react/forbid-prop-types
  anchorEl: PropTypes.any,
  children: PropTypes.element,
  anchorOrigin: PropTypes.shape({}),
  transformOrigin: PropTypes.shape({}),
  innerStyle: PropTypes.shape({}),
  innerProps: PropTypes.shape({})
};
export {
  Popover
};
//# sourceMappingURL=Popover.js.map
